import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { Stack, Fade, Typography } from '@mui/material';
import { NAlertStandalone } from '../Nemo/NAlertStandalone/NAlertStandalone';
import { useTranslation } from 'react-i18next';
import * as styles from './VerifyYourEmail.styles';
import illustration from '../../assets/images/verifyYourEmail__illustration.svg';
import { Img } from '../Primitive';
import { LoadingButton } from '@mui/lab';
import { theme } from '../../styles/theme';
import { Box, useMediaQuery } from '@mui/system';
export const VerifyYourEmail = ({ verifyEmailAction, email, variant = 'standard' }) => {
    const { t } = useTranslation();
    const [pending, setPending] = useState(false);
    const [retrySignUpSent, setRetrySignUpSent] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));
    const handleVerifyEmailClick = useCallback(async () => {
        setPending(true);
        setRetrySignUpSent(false);
        try {
            await verifyEmailAction();
            setRetrySignUpSent(true);
        }
        catch (error) {
            console.error('Action failed. Notification not displayed.');
        }
        finally {
            setPending(false);
        }
    }, [verifyEmailAction]);
    const standardContent = useMemo(() => (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: { color: theme.palette.common.primaryDark }, children: t('verifyYourEmail.textLine1', { email }) }), _jsx(Typography, { sx: { color: theme.palette.common.primaryDark }, children: t('verifyYourEmail.textLine2') })] })), [email]);
    const expiredContent = useMemo(() => (_jsx(Typography, { sx: { color: theme.palette.common.primaryDark }, children: t('verifyYourEmail.textExpired') })), []);
    return (_jsx(Fade, { in: true, timeout: 800, children: _jsxs(Stack, { sx: { gap: '24px', alignItems: 'center' }, children: [_jsx(Typography, { sx: styles.verifyYourEmailTitle, children: t(variant === 'standard' ? 'verifyYourEmail.title' : 'verifyYourEmail.titleExpired') }), _jsx(Img, { src: illustration, alt: 'Verify your email', sx: { maxWidth: '140px', order: variant === 'expired' ? -1 : 'unset' } }), variant === 'standard' ? standardContent : expiredContent, retrySignUpSent && (_jsx(Box, { sx: { width: '100%' }, children: _jsx(NAlertStandalone, { showAlert: true, type: 'success', children: variant === 'standard'
                            ? t('verifyYourEmail.actionSuccess')
                            : t('verifyYourEmail.actionExpiredSuccess', { email }) }) })), _jsx(LoadingButton, { onClick: handleVerifyEmailClick, loading: pending, sx: styles.verifyYourEmailButton(variant, isMobile), size: 'large', loadingPosition: 'end', children: _jsx("span", { children: pending ? t('verifyYourEmail.pending') : t('verifyYourEmail.action') }) })] }) }));
};
//# sourceMappingURL=VerifyYourEmail.js.map